import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'
import AddResultComponent from '../EditHostcup/Results/AddResultComponent';
import EditRound from '../EditHostcup/EditRound';
import GeneratedTeamsRound from '../EditHostcup/Teams/GeneratedTeamsRound';
import RegisterPlayerRoundFirebase from '../EditHostcup/Player/RegisterPlayerRoundFirebase';
import AllResultsRound from '../EditHostcup/Templates/AllResultsRound';
import PlayerPointsRound from '../EditHostcup/Templates/PlayerPointsRound';
import RegisteredPlayersRoundFirebase from './RegisteredPlayersRoundFIrebase';

function SingleRoundHostcupFirebase({roundId, id, type}) {



    const [show, setShow] = useState(type && type === "page" ? true : false);
    const [round, setRound] = useState();
    const [players, setPlayers] = useState([]);

    const [requestCount, setRequestCount] = useState(0);

    const [playerIds, setPlayerIds] = useState([]);

    const [activeItem, setActiveItem] = useState("1");

    useEffect(() => {

        if (players) {
            const playerIds = players.map(player => {
                return player.player_id;
            })
            setPlayerIds(playerIds);
        }

    }, [players])


    useEffect(() => {

        try {
            const roundRef = firestore.collection("hostcup").doc(id).collection("rounds").doc(roundId);
            roundRef.onSnapshot(doc => {
                const round = {id: doc.id, ...doc.data()}
                setRound(round);

                const roundLS = JSON.stringify(round)

                localStorage.setItem("currentRound", roundLS)

            });
        } catch (error) {
            
        }

    }, [id, roundId])

    function toggle() {

        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }

    }

    function toggleItem(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab);
        }
    }

    return (
        <div>
            {type === "page" ? <h2 className="text-center font-weight-bold my-3">Runde {round?.round}</h2> : (
                <div onClick={toggle} className="card card-header">
                    <div>Runde {round?.round} <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span></div>
                </div>
            )}

            {round && show && (
                <React.Fragment>

                    <div className="row my-4">
                        <div className="col-4 col-lg-3 col-xl-2">
                            <button onClick={() => toggleItem("1")} className={`btn btn-primary btn-block ${activeItem === "1" && "active"}`}>Rediger</button>
                        </div>
                        <div className="col-4 col-lg-3 col-xl-2">
                            <button onClick={() => toggleItem("4")} className={`btn btn-primary btn-block ${activeItem === "4" && "active"}`}>Resultater</button>
                        </div>
                        <div className="col-4 col-lg-3 col-xl-3">
                            <button onClick={() => toggleItem("2")} className={`btn btn-primary btn-block ${activeItem === "2" && "active"}`}>Registrerte spillere</button>
                        </div>
                        <div className="col-4 col-lg-3 col-xl-3">
                            <button onClick={() => toggleItem("3")} className={`btn btn-primary btn-block ${activeItem === "3" && "active"}`}>Genererte lag</button>
                        </div>
                        <div className="col-4 col-lg-3 col-xl-2">
                            <button onClick={() => toggleItem("5")} className={`btn btn-primary btn-block ${activeItem === "5" && "active"}`}>Poeng</button>
                        </div>
                    </div>
                    {activeItem === "1" && (
                        <React.Fragment>
                            <h4 className="my-3">Runde {round?.round} </h4>
                            <EditRound id={id} roundId={roundId} />
                            <hr />
                        </React.Fragment>
                    )}
                    {activeItem === "2" && (
                        <React.Fragment>
                            <RegisterPlayerRoundFirebase id={id} roundId={roundId} playersAdded={playerIds} />
                            <h4 className="my-3 text-center font-weight-bold">Registrerte spillere denne runden</h4>
                            <RegisteredPlayersRoundFirebase 
                                roundId={roundId} 
                                id={id} 
                                players={players} 
                                setPlayers={setPlayers} 
                                requestCount={requestCount} 
                                setRequestCount={setRequestCount} 
                            />
                        </React.Fragment>
                    )}
                    {activeItem === "3" && (
                        <GeneratedTeamsRound 
                            id={id}
                            round={round}
                            roundId={roundId}
                            players={players}
                            requestCount={requestCount}
                            setRequestCount={setRequestCount}
                            setActiveItem={setActiveItem}
                        />
                    )}
                    {activeItem === "4" && (
                        <React.Fragment>
                            <h4 className="my-3">Resultater</h4>
                            
                            <AddResultComponent roundId={roundId} hostcupId={id} />
                            <hr />
                            <h5>Trekning 1</h5>
                            <AllResultsRound roundId={roundId} hostcupId={id} draw="1" /> 

                            <h5>Trekning 2</h5>
                            <AllResultsRound roundId={roundId} hostcupId={id} draw="2" /> 

                            <h5>Trekning 3</h5>
                            <AllResultsRound roundId={roundId} hostcupId={id} draw="3" /> 
                        </React.Fragment>
                    )}
                    {activeItem === "5" && (
                        <React.Fragment>
                            <PlayerPointsRound roundId={roundId} hostcupId={id} roundData={round} />
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}

        </div>
    )

}
export default SingleRoundHostcupFirebase